import xlsx from 'xlsx';
import saveAs from 'file-saver';

/**
 * Generate an excel document.
 * 
 * @param {Array} objects array of objects to save in excel document
 * @param {Array} headers array of strings to use as headers in excel document
 * @param {String} sheetName 
 */
const generateXLS = (objects, headers, sheetName) => {
    if (objects) {
        let wb = xlsx.utils.book_new();
        wb.Props = {
            Title: sheetName,
            Subject: sheetName,
            CreatedDate: new Date()
        };

        wb.SheetNames.push(sheetName);
        let ws_data = [];
        ws_data.push(headers);
        objects.map((object, index) => {
            ws_data.push(Object.values(object));
        });

        let ws = xlsx.utils.aoa_to_sheet(ws_data);
        wb.Sheets[sheetName] = ws;
        const wbout = xlsx.write(wb, { bookType: 'xlsx', type: 'binary' });
        return wbout;
    }

    return null;
};


/**
 * Export an excel document.
 * 
 * @param {Array} data array of objects to save in excel document
 * @param {Array} headers array of strings to use as headers in excel document
 * @param {String} sheetName 
 * @param {String} fileName 
 */
export const exportToXLS = (data, headers, sheetName, fileName) => {
    const wbout = generateXLS(data, headers, sheetName);

    let buf = new ArrayBuffer(wbout.length);
    let view = new Uint8Array(buf);
    for (let i = 0; i < wbout.length; i++) {
        view[i] = wbout.charCodeAt(i) & 0xFF;
    }

    saveAs(new Blob([buf], { type: 'application/octet-stream' }), `${fileName}.xlsx`);
};


// WEBPACK FOOTER //
// ./src/components/Utils/exportToXLS.js